import Debug from 'debug';

const debug = Debug('rs:lib/store/request/reducer');

const initialState = {
  host: '',
  token: null,
  ssoOrgId: null,
  countryCode: 'GB',
};

export default function requestReducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
    case 'UPDATE_ACCESS_TOKEN':
      debug(`${action.type} payload`, action.payload);
      return {
        ...state,
        token: action.payload.access_token,
      };
    case 'LOGOUT_SUCCESS':
      return {
        ...state,
        token: null,
      };
    default:
      return state;
  }
}
